var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import moment from 'moment';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card, Image, Link, Tag, Tooltip, TooltipTrigger } from '@philips-internal/oswald-ui-components/lib/components';
import { bool, func, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import calendar from '../../assets/images/global/calendar.svg';
import locale from '../../assets/images/global/locale.svg';
import UserAvatarSVG from '../../assets/images/icons/avatar_user.svg';
import ExamAvatarSVG from '../../assets/images/avatars/avatar-exam-schedule.svg';
import ServiceAvatarSVG from '../../assets/images/global/avatar-service.svg';
import { ParseHelperUtils } from '../../util/parse-helper-utils';
import './suggestion-card-item.css';
import { getPreferredTime } from '../../util/card-util';
import SuggestionCardItemAPI from './suggestion-card-api';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import RequestImageService from '../../services/request-image-service/request-image-service';
var ScheduleType;
(function (ScheduleType) {
    ScheduleType["CONSULTATION"] = "C";
    ScheduleType["EXAM"] = "E";
    ScheduleType["SERVICE"] = "S";
})(ScheduleType || (ScheduleType = {}));
let SuggestionCardItem = class SuggestionCardItem extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            image: '',
        };
        this.getAvatar = (scheduleType) => {
            switch (scheduleType) {
                case ScheduleType.CONSULTATION:
                    return UserAvatarSVG;
                case ScheduleType.EXAM:
                    return ExamAvatarSVG;
                case ScheduleType.SERVICE:
                    return ServiceAvatarSVG;
                default:
                    return '';
            }
        };
    }
    static { this.propTypes = {
        callToWaitlistModal: func,
        cdMedico: string,
        dsEstablishment: string,
        endpointServerImage: string,
        ieAcao: string,
        ieReturn: bool,
        image: string,
        nrSeqAgeintItem: string,
        nrSeqAgenda: string,
        period: string,
        price: string,
        qtPesoMaxAgenda: string,
        removeItemFromWaitingList: func,
        selectedDate: string,
        showWaitingListModal: func,
        startDate: string,
        subtitle1: string,
        title: string,
        type: string,
    }; }
    openWaitListModal() {
        const { callToWaitlistModal, showWaitingListModal, nrSeqAgeintItem } = this.props;
        if (callToWaitlistModal) {
            this.callWaitingListModal();
        }
        else if (showWaitingListModal) {
            showWaitingListModal(nrSeqAgeintItem);
        }
    }
    callWaitingListModal() {
        const { cdMedico = '', cdEspecialidade = '', type, nrSeqProcInterno, dsProcInterno, callToWaitlistModal = null, title, nrSeqAgeintItem, nrSeqAgeint } = this.props;
        if (callToWaitlistModal == null) {
            return;
        }
        const physician = { cdPessoaFisica: cdMedico, nmPessoaFisica: cdMedico ? title : '' };
        const scheduleType = [];
        const examScheduleList = [];
        const consultScheduleList = [];
        switch (type) {
            case 'E':
                scheduleType.push({ id: 2, value: 'schedule-type.exam' });
                examScheduleList.push({
                    exam: {
                        dsImagemBase64: this.state.image,
                        dsProcInterno: dsProcInterno,
                        dsTipoExame: type,
                        nrSeqAgeintItem: nrSeqAgeintItem,
                        nrSeqProcInterno: Number(nrSeqProcInterno),
                    }
                });
                break;
            case 'C':
                scheduleType.push({ id: 1, value: 'schedule-type.consultation' });
                consultScheduleList.push({
                    nrSeqAgeintItem: nrSeqAgeintItem,
                    physician: {
                        cdPessoaFisica: cdMedico,
                        nmPessoaFisica: ''
                    },
                    specialityData: {
                        cdEspecialidade: Number(cdEspecialidade) || undefined,
                    },
                });
                break;
            default:
                break;
        }
        callToWaitlistModal({ consultScheduleList, examScheduleList, nrSeqAgeint, physician, scheduleType });
    }
    removeItemFromWaitingList(nrSeqAgeintItem) {
        const removeItem = this.props.removeItemFromWaitingList;
        if (removeItem != null) {
            removeItem(nrSeqAgeintItem);
        }
    }
    componentDidMount() {
        const { cdMedico } = this.props;
        if (cdMedico) {
            this.getCardImage();
        }
    }
    componentDidUpdate(prevProps) {
        const { cdMedico } = this.props;
        if (cdMedico !== prevProps.cdMedico) {
            if (!cdMedico) {
                this.setState({ image: '' });
            }
            else {
                this.getCardImage();
            }
        }
    }
    getCardImage() {
        const { cdMedico, endpointServerImage } = this.props;
        if (!cdMedico || !endpointServerImage) {
            this.setState({ image: '' });
            return;
        }
        this.setState({ image: '' });
        RequestImageService.getImage(endpointServerImage, { height: 64, nrSequence: cdMedico, width: 64 }).then(response => {
            this.setState({ image: response });
        });
    }
    render() {
        const { availableType, title, subtitle1, selectedDate, period, dsEstablishment, price, startDate, type, ieReturn, isShowPrice, isTeleconsultation, } = this.props;
        const avatarImage = this.getAvatar(type);
        const priceLabel = ParseHelperUtils.parseToTextHtml(price) || '';
        return (React.createElement(Card, { selectionType: SelectionType.SINGLE, className: 'suggestion-card-item', width: 12, transparent: false, uuid: generateUUID() },
            React.createElement("div", { className: 'card-awts-avatar' },
                React.createElement(Avatar, { image: this.state.image ? this.state.image : avatarImage })),
            React.createElement("div", { className: 'suggestion-card-content' },
                React.createElement("div", { className: 'left-content' },
                    React.createElement("div", { className: 'card-awts-content' },
                        React.createElement("output", null, title),
                        React.createElement("div", { className: 'card-awts-content-subtitles' },
                            React.createElement("output", null, subtitle1),
                            React.createElement("div", { className: 'info-item' },
                                React.createElement(Image, { src: calendar, className: 'info-icon', alt: '', visible: !!selectedDate }),
                                React.createElement("output", null, (period
                                    && selectedDate && moment(selectedDate).format('DD-MM-YYYY') + ' - ' + getPreferredTime(period))
                                    || ((selectedDate && moment(selectedDate).format('DD-MM-YYYY') + ' - ' + moment(startDate).format('HH:mm'))))),
                            React.createElement("div", { className: 'info-item' },
                                React.createElement(Image, { src: locale, className: 'info-icon', alt: '', visible: !!dsEstablishment }),
                                React.createElement("output", null, dsEstablishment))))),
                React.createElement("div", { className: 'right-content' },
                    React.createElement("div", { className: 'tag-list' },
                        isTeleconsultation ? this.renderAppointmentTeleconsultationTag() : '',
                        availableType === 'R' ? this.renderAppointmentRequestTag() : ''),
                    selectedDate && isShowPrice ? this.showValueOrReturn(priceLabel, ieReturn) : '',
                    this.renderWaitingListItemTag()))));
    }
    renderAppointmentTeleconsultationTag() {
        return (React.createElement(Tag, { value: MessageService.translate('patient.teleconsultation'), formatters: {} }));
    }
    renderAppointmentRequestTag() {
        return (React.createElement(Tooltip, { triggers: [TooltipTrigger.HOVER], value: MessageService.translate('patient.tooltip.request'), multiline: true },
            React.createElement("div", { className: 'tooltip-custom__target' },
                React.createElement(Tag, { value: MessageService.translate('patient.request'), formatters: {} }))));
    }
    renderWaitingListItemTag() {
        const { isItemFromReschedule, isWaitingListItem, hasSchedulingTimes, nrSeqAgeintItem, isEnabledToScheduleWaitingList } = this.props;
        if (isItemFromReschedule || hasSchedulingTimes || !isEnabledToScheduleWaitingList) {
            return React.createElement(React.Fragment, null);
        }
        if (!isWaitingListItem) {
            return (React.createElement(Link, { value: MessageService.translate('patient.button-label.enter-the-waiting-list'), onClick: () => this.openWaitListModal() }));
        }
        return (React.createElement("div", null,
            React.createElement(Tag, { value: MessageService.translate('patient.label.modal-scheduling-waiting-list'), formatters: {}, color: 'safety-orange' }),
            React.createElement(Link, { value: MessageService.translate('patient.cancel'), onClick: () => this.removeItemFromWaitingList(nrSeqAgeintItem) })));
    }
    showValueOrReturn(value, ieReturn) {
        if (ieReturn) {
            return (React.createElement("div", { className: 'return' }, MessageService.translate('patient.return')));
        }
        if (value) {
            return (React.createElement("div", { className: "info-item" },
                React.createElement("output", { className: 'price' }, value)));
        }
        return React.createElement(React.Fragment, null);
    }
};
SuggestionCardItem = __decorate([
    AwesomeComponent({ api: SuggestionCardItemAPI, type: ComponentType.DATA_DISPLAY })
], SuggestionCardItem);
export default SuggestionCardItem;
//# sourceMappingURL=suggestion-card-item.js.map